import type { MuscleVolume } from "./types";

export interface MuscleVolumeInput {
  slug: string;
  nameZh: string;
  nameJa: string;
  targetMin: number;
  targetMax: number;
  effectiveSets: number;
}

export function getVolumeStatus(
  effectiveSets: number,
  targetMin: number,
  targetMax: number
): MuscleVolume["status"] {
  if (effectiveSets < targetMin) return "low";
  if (effectiveSets > targetMax) return "high";
  return "ok";
}

export function normalizeMuscleVolumes(inputs: MuscleVolumeInput[]): MuscleVolume[] {
  return inputs
    .map((item) => ({
      slug: item.slug,
      nameZh: item.nameZh,
      nameJa: item.nameJa,
      effectiveSets: Number(item.effectiveSets.toFixed(1)),
      targetMin: item.targetMin,
      targetMax: item.targetMax,
      status: getVolumeStatus(item.effectiveSets, item.targetMin, item.targetMax)
    }))
    .sort((a, b) => b.effectiveSets - a.effectiveSets || a.slug.localeCompare(b.slug));
}

export function getLocalDateString(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getJapanDateString(date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function addDaysToDateString(dateString: string, days: number): string {
  const date = new Date(`${dateString}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function isNextDayRecoveryWindow(trainedOn: string, today: string): boolean {
  return addDaysToDateString(trainedOn, 1) === today;
}

export function getWeekRange(dateString: string): { weekStart: string; weekEnd: string } {
  const date = new Date(`${dateString}T00:00:00`);
  const day = date.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;
  const monday = new Date(date);
  monday.setDate(date.getDate() + mondayOffset);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return {
    weekStart: getLocalDateString(monday),
    weekEnd: getLocalDateString(sunday)
  };
}
